import { useAuthStore } from '@/infrastructure/store/authStore';

export const useAuth = () => {
  const store = useAuthStore();
  return {
    user: store.user,
    isAuthenticated: store.isAuthenticated,
    isLoading: store.isLoading,
    redirectPath: store.redirectPath,
    login: store.login,
    signup: store.signup,
    checkAuth: store.checkAuth,
    logout: store.logout,
    setRedirectPath: store.setRedirectPath,
    clearRedirectPath: store.clearRedirectPath,
    addPurchasedSubcategory: store.addPurchasedSubcategory,
    isAdmin: store.user?.role === 'ADMIN' || store.user?.role === 'SUPER_ADMIN',
  };
};
